import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Amplify, Auth } from "aws-amplify";
import { USER_AUTH_CONFIG } from "../aws-config";
import { useToast } from "../common/toast";
import CircularProgress from "@mui/material/CircularProgress";

const UserLoginCallback = () => {
  const history = useHistory();
  const { errorToast } = useToast();

  useEffect(() => {
    handleCallback();
  }, []);

  const handleCallback = async () => {
    try {
      Amplify.configure(USER_AUTH_CONFIG);
      await Auth.currentSession();
    } catch (error) {
      console.error("Error during callback handling", error);
      errorToast("Sign-in Error!");
      history.replace("/user-login");
      return;
    }
    window.location.href = "/";
  };

  return (
    <div
      className="flex items-center justify-center"
      style={{
        height: "100vh",
      }}
    >
      <CircularProgress />
    </div>
  );
};

export default UserLoginCallback;
